export const NOTIFICATION_INLINE_ACTIONS = [
  {
    callback: () =>
      window.alert('Clicked inline text button. Wow! Nice to see you.'),
    text: 'Text button',
  },
  {
    callback: () =>
      window.alert('Clicked inline text button. Wow! Nice to see you.'),
    text: 'Text button',
  },
]

export const NOTIFICATION_ERROR_TEXT = 'Error notification'

export const NOTIFICATION_INFO_TEXT = 'Information notification'

export const NOTIFICATION_SUCCESS_TEXT = 'Success notification'

export const NOTIFICATION_WARNING_TEXT = 'Warning notification'
